import Login from "pages/Login"
import Dashboard from "pages/Dashboard/Dashboard"
import Rooms from "pages/Rooms/Rooms"
import Tenant from "pages/Tenant/Tenant"
import TenantForm from "pages/Tenant/TenantForm"
import Booking from "pages/Booking/Booking"
import BookingForm from "pages/Booking/BookingForm"
import Setting from "pages/Setting/Setting"
import RoomType from "pages/Setting/RoomType/RoomType"
import RoomTypeForm from "pages/Setting/RoomType/RoomTypeForm"
import RoomSetup from "pages/Setting/RoomSetup/RoomSetup"
import RoomSetupForm from "pages/Setting/RoomSetup/RoomSetupForm"
import Payment from "pages/Payment/Payment"
import PaymentForm from "pages/Payment/PaymentForm"
import Expense from "pages/Expense/Expense"
import ExpenseForm from "pages/Expense/ExpenseForm"
import User from "pages/Setting/User/User"
import UserForm from "pages/Setting/User/UserForm"
import DepositReturn from "pages/DepositReturn/DepositReturn"
import DepositReturnForm from "pages/DepositReturn/DepositReturnForm"
import TenantRegistration from "pages/Tenant/TenantRegistration"
import MainContainer from "components/layout/MainContainer"
import Reports from "pages/Reports/Reports"
import DetailPaymentReport from "pages/Reports/DetailPaymentReport/DetailPaymentReport"
import DetailBookingReport from "pages/Reports/DetailBookingReport/DetailBookingReport"

export const routes = [{
   	element: <MainContainer />,
   	children:[
		{
			path: "/login",
			element: <Login />
		},
		{
			path: "/",
			element: <Dashboard />
		},
		{
			path: "/rooms",
			element: <Rooms />
		},
		{
			path: "/tenant",
			element: <Tenant />
		},
		{
			path: "/tenant/form",
			element: <TenantForm />
		},
		{
			path: "/booking",
			element: <Booking />
		},
		{
			path: "/booking/form",
			element: <BookingForm />
		},
		{
			path: "/payment",
			element: <Payment />
		},
		{
			path: "/payment/form",
			element: <PaymentForm />
		},
		{
			path: "/expense",
			element: <Expense />
		},
		{
			path: "/expense/form",
			element: <ExpenseForm />
		},
		{
			path: "/deposit",
			element: <DepositReturn />
		},
		{
			path: "/deposit/form",
			element: <DepositReturnForm />
		},
		{
			path: "/setting",
			element: <Setting />
		},
		{
			path: "/setting/room-type",
			element: <RoomType />
		},
		{
			path: "/setting/user",
			element: <User />
		},
		{
			path: "/setting/user/form",
			element: <UserForm />
		},
		{
			path: "/setting/room-type/form",
			element: <RoomTypeForm />
		},
		{
			path: "/setting/room-setup",
			element: <RoomSetup />
		},
		{
			path: "/setting/room-setup/form",
			element: <RoomSetupForm />
		},
		{
			path: "/tenant-registration",
			element: <TenantRegistration />
		},

		// REPORTS
		{
			path: "/reports",
			element: <Reports />
		},
		{
			path: "/reports/detail-payment-report",
			element: <DetailPaymentReport />
		},
		{
			path: "/reports/detail-booking-report",
			element: <DetailBookingReport />
		},
	]
}]